<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Ajuste de estoque</p>
    </div>

    <div>
      <lista-unidades-select
        class="row col-2"
        v-model="unidade"
      ></lista-unidades-select>
    </div>

    <div class="q-mt-lg">
      <q-table
        title="Produtos (refine sua busca, aqui aparecerão somente os 50 primeiros resultados)"
        flat
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        :rows="rows"
        dense
        class="tabela-tamanho-fixo"
        :columns="columns"
        :loading="disable"
        v-model:pagination="pagination"
        hide-pagination
        row-key="id_produto"
        selection="multiple"
        v-model:selected="produto"
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filter"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search"></q-icon>
            </template>
          </q-input>
        </template>

        <template #body-cell-link="props">
          <q-td>
            <span v-if="props.row.codigo_ca">
              {{ props.row.codigo_ca }}
            </span>
          </q-td>
        </template>
        <template #body-cell-description="props">
          <q-td>
            <span>
              {{ props.row.descricao_do_produto }}
            </span>
          </q-td>
        </template>
        <template #body-cell-qtd_estoque="props">
          <q-td>
            <span>
              {{ props.row.qtd_estoque || 0 }}
            </span>
          </q-td>
        </template>
        <template #body-cell-qtd_machine="props">
          <q-td>
            <span>
              {{ props.row.qtd_machine || 0 }}
            </span>
          </q-td>
        </template>
        <template #body-cell-qtd_total="props">
          <q-td>
            <span>
              {{ props.row.qtd_total_estoque || 0 }}
            </span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <selecionados
      class="q-mt-md"
      :produtos="produto"
      @resetarProdutos="reset"
    />
  </q-page>
</template>

<script>
const columns = [
  {
    name: "code",
    label: "Código",
    field: "codigo_produto",
    align: "left",
  },
  {
    name: "description",
    label: "Descrição",
    field: "descricao_do_produto",
    align: "left",
  },
  {
    name: "link",
    label: "CA",
    field: "codigo_ca",
    align: "left",
  },
  {
    name: "qtd_estoque",
    label: "Quantidade Estoque",
    field: "qtd_estoque",
    align: "left",
  },
  {
    name: "qtd_machine",
    label: "Quantidade Máquina",
    field: "qtd_machine",
    align: "left",
  },
  {
    name: "qtd_total",
    label: "Quantidade Total",
    field: "qtd_total_estoque",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import Selecionados from "../components/Selecionados.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
//import { useQuasar } from "quasar";

export default {
  components: { Selecionados, ListaUnidadesSelect },
  props: ["atualizar"],
  setup(props) {
    const store = useStore();

    const link = ref("");
    //const $q = useQuasar();
    const unidade = ref();
    const rows = ref([]);
    const disable = ref(true);

    let filter = ref("");
    const produto = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 50,
      rowsNumber: 10,
    });

    const getProdutos = async (page = 1, rowsPerPage = 50) => {
      disable.value = true;

      let response = await store.dispatch("ajusteEstoque/getStockReport", {
        vendor_id: store.state.org.unidadeData.id,
        product: filter.value,
        page: page,
        perPage: rowsPerPage,
      });

      rows.value = response.data.results.data || [];
      pagination.value.rowsNumber = response.data.results.total || 0;
      pagination.value.page = response.data.results.current_page || 1;

      disable.value = false;
    };

    onMounted(() => {
      getProdutos();
    });

    const handleRequest = async () => {
      getProdutos(pagination.value.page, pagination.value.rowsPerPage);
    };

    const reset = async () => {
      produto.value = [];
    };

    watch(
      () => pagination.value.page,
      () => {
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getProdutos();
        }, 1000);
      }
    );

    watch(
      () => filter.value,
      () => {
        pagination.value.page = 1;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        produto.value = [];
        pagination.value.page = 1;
        getProdutos();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      columns,
      rows,
      getProdutos,
      pagination,
      handleRequest,
      disable,
      filter,
      unidade,
      link,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      produto,
      reset,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
